import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sera-info-text',
    templateUrl: './sera-info-text.component.html',
    styleUrl: './sera-info-text.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraInfoTextComponent implements OnInit {
    icon: string = 'ci-information';

    @Input()
    typeOfText: 'neutral' | 'info' | 'positive' | 'caution' | 'critical' = 'neutral';

    @Input()
    text: string = '';

    setIconBasedOnType() {
        switch (this.typeOfText) {
            case 'neutral':
                this.icon = 'ci-information';
                break;
            case 'info':
                this.icon = 'ci-information ci--blue';
                break;
            case 'positive':
                this.icon = 'ci-check ci--green';
                break;
            case 'caution':
                this.icon = 'ci-alert';
                break;
            case 'critical':
                this.icon = 'ci-error ci--red';
                break;
        }
    }

    ngOnInit() {
        this.setIconBasedOnType();
    }
}
